module.exports = __webpack_public_path__ + "static/media/Alert.ecba6d0b.wav";